/** Root layout for a rendered response. Split out to keep markdownSx.js under the cap. */
export const markdownRootSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  font: 'inherit',
  color: 'var(--app-text-primary)',
  // Long URLs and unbroken tokens must not widen the thread column.
  overflowWrap: 'anywhere',
}
